import React from 'react';
import { graphql } from 'gatsby';

import Layout from '@/components/Layout';

// Transcription du PDF static/files/cgu-la-fraise.pdf, sans modification du fond.
// La numérotation d’origine est conservée (le document ne contient pas d’article 15).
const Legal = () => (
  <Layout
    title="Conditions générales d’utilisation"
    description="Conditions générales d’utilisation de La Fraise, mentions légales et traitement des données personnelles."
  >
    <main lang="fr" className="mx-auto max-w-4xl px-6 py-12 md:py-20">
      <h1 className="!text-3xl md:!text-5xl !leading-tight !mb-10">
        Conditions générales d’utilisation de La Fraise.
      </h1>
      <nav
        aria-label="Sommaire des conditions générales d’utilisation"
        className="rounded-2xl bg-smoothGrey p-6 mb-12"
      >
        <h2 className="!text-2xl !leading-tight !mb-4">Sommaire</h2>
        <ul className="space-y-2">
          <li>
            <a className="underline hover:no-underline" href="#article-1">
              Article 1 – Définitions
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-2">
              Article 2 – Mentions légales
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-3">
              Article 3 - Objet et champ d’application des CGU
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-4">
              Article 4 – Objet de l’Application
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-5">
              Article 5 – Accès et fonctionnement de l’Application
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-6">
              Article 6 – Création d’un compte personnel d’utilisateur
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-7">
              Article 7 – Limitation des responsabilités
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-8">
              Article 8 – Tarifs et modalités financières
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-9">
              Article 9 – Les obligations de l’Utilisateur
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-10">
              Article 10 – Les obligations du Charrette Club
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-11">
              Article 11 – La durée
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-12">
              Article 12 – Droit de la propriété intellectuelle relatifs aux
              éléments de l’Application
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-13">
              Article 13 : Droit d’usage de l’Application par l’Utilisateur
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-14">
              Article 14 – Régime de traitement des données personnelles
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-16">
              Article 16 – Accès à l’application par connexion internet
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-17">
              Article 17 – Fermeture de compte
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-18">
              Article 18 – Réclamations
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-19">
              Article 19 – Évolution des conditions générales d’utilisation
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-20">
              Article 20 – Nullité d’une clause des CGU
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-21">
              Article 21 – Résiliation
            </a>
          </li>
          <li>
            <a className="underline hover:no-underline" href="#article-22">
              Article 22 – Loi applicable - Litige - Langue
            </a>
          </li>
        </ul>
      </nav>
      <article className="space-y-6 text-base leading-relaxed break-words">
        <h2
          id="article-1"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 1 – Définitions
        </h2>
        <p>
          Les termes débutant par une majuscule au sein des présentes CGU,
          qu’ils soient utilisés indifféremment au singulier ou au pluriel,
          auront, la signification qui leur est donnée ci-après :
        </p>
        <p>
          « Application » désigne l’application logicielle « La Fraise » éditée
          et fournie par Le Charrette Club, donnant accès aux différentes
          fonctionnalités de l’Application, qui est disponible gratuitement dans
          l’« Apple Store » d’Apple et le « Play Store » de Google pour être
          téléchargée par l’Utilisateur sur son terminal Apple iOS et Android.
          L’Application comprend également les Contenus, les logiciels, les
          programmes, les outils (de programmation, de navigation, …), les bases
          de données, les systèmes d’exploitation, la documentation et tous
          autres éléments et services qui la composent, les mises à jour et les
          nouvelles versions qui peuvent être apportées à l’Application par Le
          Charrette Club.
        </p>
        <p>
          « Contenu » désigne sans que cette liste soit limitative, la structure
          de l’Application, le contenu éditorial, les dessins, les
          illustrations, les images, les photographies, les chartes graphiques,
          les marques, les logos, les sigles, les dénominations sociales, les
          œuvres audiovisuelles, les œuvres multimédias, les contenus visuels,
          les contenus audio et sonores, ainsi que tout autre contenu présent au
          sein de l’Application et/ou tout autre élément composant
          l’Application.
        </p>
        <p>
          « Site » désigne le site web de La Fraise dont l’adresse est la
          suivante : https://lafraise.app
        </p>
        <p>
          « Utilisateur » ou « Vous » désigne une personne physique majeure ou
          mineure ayant préalablement obtenu l’autorisation parentale ou du
          responsable légal, et ayant téléchargé l’Application pour ses besoins
          propres, dans le cadre d’un usage strictement personnel et non
          commercial, sans but lucratif direct ou indirect.
        </p>
        <h2
          id="article-2"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 2 – Mentions légales
        </h2>
        <p>
          L’application est éditée par le Charrette Club, filiale du Charrette
          Family, immatriculée au RCS Paris, SIREN 881 057 673 - code NAF 6420Z
          - Numéro de TVA intracommunautaire : FR49881057673
        </p>
        <p>
          Directeur de publication : Nicolas Bertrand (nicolas@charrette.club)
        </p>
        <p>
          Les données de l’application sont hébergées en Europe par Amazon Web
          Services, Inc. P.O. Box 81226 Seattle, WA 98108-1226 USA.
        </p>
        <h2
          id="article-3"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 3 - Objet et champ d’application des CGU
        </h2>
        <p>
          Les présentes Conditions Générales d’Utilisation ci-après dénommées
          “CGU” régissent les rapports entre La Fraise et l’Utilisateur sans
          restriction ni réserve pour toute la durée de l’utilisation ou du
          téléchargement de l’Application.
        </p>
        <p>
          L’Utilisateur en se connectant à l’Application accepte les présentes
          Conditions Générales d’Utilisation.
        </p>
        <p>
          Les présentes CGU sont accessibles à tout moment dans l’Application
          mobile dans la rubrique “MENTIONS LEGALES” et sur le Site de
          l’Application. Ces CGU prévaudront, le cas échéant, sur toute autre
          version ou tout autre document contradictoire.
        </p>
        <p>
          La Fraise se laisse la possibilité de modifier à tout moment les
          présentes CGU, sans préavis et sans avoir à la communiquer en amont à
          l’Utilisateur. L’Utilisateur sera informé de la publication des CGU
          modifiées par mail ou au travers d’une notification dans
          l’Application. La poursuite de l’usage de l’Application par
          l’Utilisateur suite à la publication des nouveaux CGU constitue son
          autorisation à ces derniers.
        </p>
        <p>
          Le Charrette Club conseille fortement à l’Utilisateur de lire très
          attentivement les présentes CGU ainsi les CGU mises à jour, dans la
          rubrique CGU et sur le Site lafraise.app
        </p>
        <p>
          Dans la situation où l’Utilisateur ne consent pas aux présentes CGU,
          il ne doit pas utiliser l’Application; par conséquent Le Charrette
          Club recommande de désinstaller l’Application.
        </p>
        <p>
          Pour rappel, l’Utilisateur qui s’inscrit sur l’Application confirme
          avoir pris connaissance des présentes CGU et les accepte sans réserve.
        </p>
        <h2
          id="article-4"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 4 – Objet de l’Application
        </h2>
        <p>
          La Fraise propose la consultation d’une large base de données de
          produits alimentaires intégrant des informations relatives à leur
          consommation chez la femme enceinte. L’objectif de l’Application est
          de fournir à l’Utilisateur une information complète, centralisée, et
          vérifiée par des professionnels de la nutrition.
        </p>
        <h2
          id="article-5"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 5 – Accès et fonctionnement de l’Application
        </h2>
        <p>
          Pour accéder et utiliser l’Application, Vous devez posséder un
          téléphone compatible ou un terminal mobile et un accès au réseau
          Internet. L’Application est téléchargeable gratuitement depuis les
          plateformes « Apple Store » et « Google Play Store » sur les terminaux
          mobiles suivants :
        </p>
        <ul className="list-disc pl-6 space-y-3">
          <li>
            Téléphone mobile Iphone® d’Apple® disposant au moins du système
            d’exploitation iOS 9
          </li>
          <li>
            Téléphone mobile disposant du système d’exploitation Android® OS 4.4
            jusqu’à OS 4.4.
          </li>
        </ul>
        <p>
          La version du logiciel de l’Application peut être mise à jour pour
          ajouter de nouvelles fonctions et de nouveaux services.
        </p>
        <p>
          Ainsi, Vous devez donc disposer d’un smartphone, d’un accès internet
          et d’un compte personnel utilisateur (Cf. article 6).
        </p>
        <p>Les fonctionnalités de La Fraise sont les suivantes :</p>
        <ul className="list-disc pl-6 space-y-3">
          <li>
            création de compte pour l’Utilisateur au sein de l’Application
          </li>
          <li>
            consultation d’une base de données de produits alimentaires
            fournissant des informations relatives à leur consommation durant la
            grossesse
          </li>
          <li>
            consultation des dernières recherches effectuées ainsi que du nombre
            total de recherches effectuées sur l’application par l’Utilisateur
          </li>
          <li>édition, suppression du compte de l’Utilisateur</li>
        </ul>
        <h2
          id="article-6"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 6 – Création d’un compte personnel d’utilisateur
        </h2>
        <p>
          Pour pouvoir accéder à La Fraise, l’Utilisateur doit au préalable
          procéder à son inscription en créant son compte utilisateur. Pour
          cela, Vous devez remplir le formulaire d’inscription au démarrage de
          l’Application et renseigner les informations suivantes visibles sur le
          profil utilisateur : Nom / Prénom / Sexe / Email et Numéro de
          téléphone.
        </p>
        <p>
          Il Vous est possible de vous inscrire par le biais de Facebook ou
          d’Apple connect.
        </p>
        <p>
          Dans le cas où vous oubliez votre mot de passe, Vous avez la
          possibilité d’écrire à l’adresse suivante : bonjour@charrette.club
        </p>
        <p>
          Le renseignement de ces données lors de l’inscription sont
          indispensable à l’accès à l’Application; c’est pourquoi, les
          informations fournies sont vraies, sincères et complètes. De plus, ces
          données doivent toujours être mises à jour par l’Utilisateur.
        </p>
        <h2
          id="article-7"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 7 – Limitation des responsabilités
        </h2>
        <h3 className="!text-xl !leading-snug">
          Article 7.1 – Exonération de responsabilité de l’Utilisateur
        </h3>
        <p>
          L’Utilisateur reste seul responsable de tout usage qui pourrait être
          fait à ses identifiants et mot de passe, et de leur confidentialité;
          ainsi que de toute utilisation de son compte personnel.
        </p>
        <p>
          L’Utilisateur est entièrement responsable de l’utilisation faite de
          l’Application ainsi que des décisions qu’il pourrait prendre après
          avoir consulté les informations contenues dans l’Application.
          Autrement dit, l’utilisation des informations de l’Application par
          l’Utilisateur est exclusivement de sa responsabilité.
        </p>
        <p>
          Afin que l’Utilisateur soit exonéré de toute responsabilité,
          l’Utilisateur s’engage à informer dans les plus brefs délais Le
          Charrette Club de toute utilisation ou risque d’utilisation
          frauduleuse de son Compte ainsi que d’une atteinte ou potentielle
          atteinte à la sécurité de ses identifiants (mot de passe inclus) à
          l’adresse mail suivante : bonjour@charrette.club
        </p>
        <h3 className="!text-xl !leading-snug">
          Article 7.2 – Exonération de la responsabilité du Charrette Club
        </h3>
        <p>
          Le Charrette Club ne pourra pas être tenu pour responsable de tout
          dommage direct ou indirect, de quelque nature que ce soit, causé par
          une mauvaise utilisation ou une utilisation illégale de l’Application
          par l’Utilisateur. Également, Le Charrette Club n’est pas responsable
          des informations ou tout autre contenu communiqué, transmis ou diffusé
          par l’Utilisateur à l’occasion de l’utilisation de l’Application. De
          plus, Le Charrette Club ne pourra être tenu pour responsable de tout
          manquement quelconque par l’Utilisateur des présentes CGU.
        </p>
        <p>
          Le Charrette Club s’exonère de toutes responsabilités liées aux
          dommages pouvant être causés en lien (direct ou indirect) avec les
          informations énoncées dans l’Application. L’utilisation des
          informations de l’Application par l’Utilisateur est exclusivement de
          sa responsabilité.
        </p>
        <p>
          Le Charrette Club se réserve le droit à tout moment de modifier,
          interrompre (temporairement ou définitivement) l’accès à La Fraise, et
          ce, sans avoir à en informe au préalable l’Utilisateur.
        </p>
        <p>
          Le Charrette Club ne s’engage pas à maintenir un accès permanent,
          constant et ininterrompu à l’Application. Le Charrette Club n’est pas
          tenu pour responsable des interruptions qui ne sont pas de son fait et
          des conséquences qui peuvent en découler pour l’Utilisateur. Plus
          précisément, le Charrette Club ne sera pas responsable du
          fonctionnement inadéquat de l’Application s’il résulte d’opérations de
          maintenance, d’incidents, de problèmes liés à sa capacité à supporter
          les systèmes indispensables à l’utilisation du service ou en cas de
          survenance de cas de force majeur. Néanmoins, Le Charrette Club mettra
          tout en oeuvre afin rétablir un fonctionnement normal de
          l’Application.
        </p>
        <p>
          Le Charrette Club ne pourra en aucun cas être tenu responsable de
          toute perte ou vol ou tout dommage résultant d’une utilisation
          frauduleuse des données d’identification de l’Utilisateur.
        </p>
        <p>
          Le Charrette Club n’est pas non plus responsable de la mauvaise
          configuration du terminal mobile de l’Utilisateur. Il appartient à
          l’Utilisateur de s’assurer du bon fonctionnement et de la
          configuration de son matériel.
        </p>
        <h2
          id="article-8"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 8 – Tarifs et modalités financières
        </h2>
        <p>
          Le téléchargement et l’utilisation de l’Application La Fraise sont
          gratuits. Tous les services proposés par l’Application sont gratuits.
        </p>
        <h2
          id="article-9"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 9 – Les obligations de l’Utilisateur
        </h2>
        <p>
          L’objectif de l’Application est d’informer l’Utilisateur (notamment
          les femmes enceintes et leur entourage) quant aux caractéristiques des
          produits alimentaires et aux risques qu’ils peuvent représenter selon
          des régimes spéciaux. Toute utilisation intentionnelle ou non
          intentionnelle de l'Application contraire à cette finalité sera
          considérée comme une atteinte au respect des présentes CGU. Cette
          atteinte aura pour sanction la fermeture temporaire ou définitive du
          compte personnel de l’Utilisateur.
        </p>
        <p>
          Le matériel nécessaire au téléchargement et à l’utilisation de
          l’Application est exclusivement à la charge de l’Utilisateur.
        </p>
        <p>
          L’Utilisateur a l’obligation de fournir des informations vraies,
          complètes et sincères lors de l’inscription de l’Application
          conformément à l’article 6 des présentes CGU. L’Utilisateur s’engage
          également à mettre à jour ses informations.
        </p>
        <p>
          L’Utilisateur s’engage à utiliser l’Application et son contenu de
          manière adéquate et licite conformément à la législation en vigueur,
          les présentes CGU, la morale, les bonnes moeurs et l’ordre public.
        </p>
        <p>
          L’Utilisateur utilisant l’Application à des fins interdites par la Loi
          sera exposé à des poursuites judiciaires et les données permettant son
          identification pourront être fournies aux autorités compétentes en cas
          de procédure judiciaire engagée contre l’Utilisateur.
        </p>
        <p>
          Sans que cette liste soit limitative, l’Utilisateur est informé qu’il
          lui est formellement interdit:
        </p>
        <ul className="list-disc pl-6 space-y-3">
          <li>
            D’entreprendre une utilisation non-autorisée ou frauduleuse de
            l’application et/ou de ses contenus à des fins ou effets illicites ;
          </li>
          <li>
            D’accéder ou essayer d’accéder à des ressources ou aires restreintes
            de l’Application, sans respecter les conditions exigées pour cet
            accès ;
          </li>
          <li>
            D’introduire ou de diffuser sur le réseau des virus informatiques ou
            tout autre système physique ou logique qui soient susceptibles de
            provoquer des dommages sur les systèmes physiques ou logiques du
            propriétaire de l’Application, de ses fournisseurs, des autres
            Utilisateurs ou de tout tiers;
          </li>
          <li>
            De porter atteinte de quelque façon que ce soit au droit au respect
            de la vie privée et au droit à l’image des autres Utilisateurs ou de
            tout tiers. Notamment, il est formellement interdit de diffuser des
            photos ou images faisant apparaître de manière reconnaissable des
            tiers sans leur autorisation ou l’autorisation de leur représentant
            légal, sous peine de porter atteinte à leur droit à l’image ;
          </li>
          <li>
            De télécharger, envoyer, diffuser transmettre tout Contenu qui
            pourrait être constitutif de fausse déclaration, d'atteinte à
            l'autorité de la Justice ou qui contiendrait des informations
            confidentielles ;
          </li>
          <li>
            D’emprunter une fausse identité. L’Utilisateur ne doit pas se faire
            passer pour un autre Utilisateur, ou pour toute autre personne qu'il
            n'est pas, ou communiquer sous un faux nom, une fausse qualité ou un
            pseudonyme qu'il n'est pas autorisé, ni habilité à utiliser, ni
            mentir sur sa qualité de majeur ou de mineur.
          </li>
        </ul>
        <h2
          id="article-10"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 10 – Les obligations du Charrette Club
        </h2>
        <p>
          Le Charrette Club s’engage à fournir une Application conforme aux
          présentes CGU.
        </p>
        <p>
          Le Charrette Club se réserve le droit de modifier, à tout moment et
          sans préavis, toute information ou contenu figurant dans La Fraise
          soit dans le cadre d’une mise à jour soit afin de corriger une erreur
          ou une inexactitude. Cette action n’ouvre droit à aucune réparation ou
          indemnisation pour l’Utilisateur.
        </p>
        <h2
          id="article-11"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 11 – La durée
        </h2>
        <p>
          Les présentes CGU sont souscrites après acceptation lors de
          l’inscription à l’Application par l’Utilisateur jusqu’à la
          désinstallation de l’Application.
        </p>
        <h2
          id="article-12"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 12 – Droit de la propriété intellectuelle relatifs aux
          éléments de l’Application
        </h2>
        <h3 className="!text-xl !leading-snug">
          Article 12.1 – Protection de la marque La Fraise
        </h3>
        <p>
          L’ensemble du contenu de La Fraise et de son Site internet
          c’est-à-dire les photographies, logos, images, sons, vidéo,
          graphiques, textes, mise en page ou illustrations ainsi que sa
          structure, les bases de données, logiciels, codes et tout autre
          matériel et élément visuel composant l’Application est protégé,
          notamment par le droit des dessins et modèles, le droit d'auteur, le
          droit des marques ainsi que le droit à l'image et plus généralement le
          droit de la propriété intellectuelle. Par conséquent, l’Utilisateur ne
          peut en aucun cas copier ou imiter en tout ou partie de ces éléments
          sauf autorisation préalable et expresse du Charrette Club.
        </p>
        <p>
          L’Utilisateur ne respectant pas les dispositions légales applicables
          se rend coupable du délit de contrefaçon et est passible des sanctions
          pénales prévues par la loi.
        </p>
        <p>
          Le Charrette Club reste exclusivement le seul titulaire de ces droits.
        </p>
        <h3 className="!text-xl !leading-snug">
          Article 12.2 – Titres de propriété intellectuelle du Charrette Club
        </h3>
        <p>
          Les présentes CGU n’emportent aucune cession d’aucune sorte de droits
          de propriété intellectuelle sur les éléments appartenant au Charrette
          Club. Par conséquent, l’Utilisateur s’engage notamment à respecter les
          droits de propriété intellectuelle attachés aux éléments composant
          l’Application.
        </p>
        <p>
          De surcroît, l’Utilisateur ne peut en aucun cas diffuser, publier,
          transmettre, céder à tout tiers, exploiter à des fins commerciales,
          reproduire, copier ou modifier sans autorisation préalable et expresse
          du Charrette Club les éléments notamment matériels et visuels
          composant et appartenant à l’Application. Par ailleurs, toute
          extraction ou réutilisation des données contenues dans l’Application,
          au-delà de son usage normal est strictement interdite à l’Utilisateur.
        </p>
        <h2
          id="article-13"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 13 : Droit d’usage de l’Application par l’Utilisateur
        </h2>
        <p>
          L’Utilisateur dispose uniquement d'un droit d'usage qui lui est
          strictement personnel, non exclusif et non transférable de
          l’Application. Tout autre usage est soumis à l’autorisation préalable
          et expresse du Charrette Club. Toute reproduction, représentation ou
          diffusion, y compris l’addition à celle-ci de nouvelles fonctions ou
          la réalisation de modifications sur celle-ci qui altéreraient son
          fonctionnement, par quelque moyen que ce soit et sur quelque support
          que ce soit, est formellement interdite.
        </p>
        <p>
          Le droit d’utilisation de l’Application est accordé en vertu des
          présentes CGU. Ce droit pourra être résilié à tout moment par
          l’Utilisateur. La résiliation s’effectue par la désinstallation de
          l’Application sur l’ensemble des appareils de l’Utilisateur; ou par la
          résiliation des présentes selon les termes de l’article 23.
        </p>
        <h2
          id="article-14"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 14 – Régime de traitement des données personnelles
        </h2>
        <h3 className="!text-xl !leading-snug">
          Article 14.1 – Licence d'utilisation des contenus mis en ligne par
          l’Utilisateurs
        </h3>
        <p>
          L’Utilisateur par la mise en ligne sur l’Application des informations
          protégés par des droits de propriété intellectuelle, tels que les
          photos, textes ou vidéos accorde de facto une licence non exclusive,
          transférable, sous-licenciable, sans redevance et mondiale pour
          l’utilisation de ces contenus de propriété intellectuelle publiés au
          Charrette Club.
        </p>
        <p>
          Cette licence est consentie pour le monde entier et s’applique jusqu’à
          la suppression de leurs contenus ou du compte. L'Utilisateur reste le
          seul responsable du contenu publié et partagé par lui via
          l’Application. Ainsi, l’Utilisateur garantit au Charrette Club que les
          données et contenus transmis par lui via l’Application ne portent pas
          atteinte aux droits de propriété intellectuelle ou droit à l’image de
          tiers et garantit au Charrette Club contre toute action en Justice que
          pourraient intenter des tiers en revendication de leurs droits de
          propriété intellectuelle sur les données et contenus transmis via
          l’Application.
        </p>
        <h3 className="!text-xl !leading-snug">
          Article 14. 2 – Registre de traitement des données personnelles
        </h3>
        <p>
          L’utilisation de l’Application par l’Utilisateur entraîne le
          traitement par Charrette Club des données personnelles de celui-ci.
        </p>
        <p>
          Conformément à la loi 78-17 du 6 janvier 1978, les données
          personnelles seront conservées se trouve sous la responsabilité du
          Charrette Club.
        </p>
        <p>
          Les données personnelles collectées sont utilisées avec pour seule
          finalité de permettre la bonne exécution de l’Application. La collecte
          des données personnelles recueillies par le biais de La Fraise est
          nécessaire au bon fonctionnement de l’Application. Cette collecte est
          obligatoire pour accéder à l’Application. A défaut de renseignement,
          l’Utilisateur ne pourra s’inscrire et créer un compte personnel sur
          l’Application. Ainsi, l’accès aux services proposés par La Fraise sera
          impossible.
        </p>
        <p>
          Le Charrette Club s’engage à conserver les données personnelles de
          l’Utilisateur de façon à permettre le respect de leur intégrité et
          durant de conservation imposées par la législation en vigueur.
        </p>
        <p>
          Plus précisément, le Charrette Club ne va conserver que certaines
          données personnelles collectées au travers de la souscription et de
          l’utilisation de l’Application. Ces données sont :
        </p>
        <ul className="list-disc pl-6 space-y-3">
          <li>Prénom</li>
          <li>Nom de Famille</li>
          <li>Email</li>
          <li>Numéro de téléphone</li>
          <li>Sexe de l’Utilisateur</li>
          <li>Date d’accouchement</li>
        </ul>
        <p>
          Dans le cas où l’Utilisateur s’identifie via son profil Facebook,
          alors Le Charrette Club pourra avoir accès à l’email associé à son
          compte ainsi qu’à son profil public.
        </p>
        <p>
          Les membres du personnel du Charrette Club pourront avoir accès aux
          données personnelles collectées ainsi qu’à tout tiers chargé de
          participer à la mise en place, à la réalisation ou au suivi des
          services proposés par l’Application (personnel, partenaires,
          sous-traitant, freelance). Les membres du personnel du Charrette Club
          ainsi que les tiers désignés par ce dernier pourront utiliser les
          données personnelles collectées dans le seul but de fournir,
          d’améliorer les services proposés par La Fraise.
        </p>
        <p>
          Les données personnelles collectées ne seront cédées à d’autres tiers,
          que ce soit à titre gracieux ou onéreux, sans l’autorisation au
          préalable de l’Utilisateur, à l’exception des cas prévus à l’article
          23 des présentes CGU.
        </p>
        <h3 className="!text-xl !leading-snug">
          14.3 – Droit d’accès, modification et suppression des données
          collectées
        </h3>
        <p>
          Conformément aux articles 39 et suivants de la loi n° 78-17 du 6
          janvier 1978, modifiée par la loi n° 2004-801 du 6 août 2004, relative
          à l’informatique, aux fichiers et aux libertés, le Charrette Club
          s’engage à transmettre sur demande de l’Utilisateur ses données
          personnelles. Ainsi, l’accès à ces données permet à l’Utilisateur de
          rectifier, de supprimer ou de s’opposer au traitement de toute ou
          partie des données qui ne sont pas indispensables au bon
          fonctionnement de l’Application.
        </p>
        <p>
          Pour ce faire, l’Utilisateur peut adresser à tout moment sa demande
          par courrier électronique à l’adresse : contact@charrette.club
        </p>
        <p>
          Le Charrette Club s’engage à répondre à la demande de l’Utilisateur
          sous un mois à partir de la réception de cette dernière.
        </p>
        <p>
          A cet effet, les données personnelles conservées au sein des registres
          informatiques du Charrette Club sont : les noms ou prénoms, l’adresse
          email, le mot de passe, l’adresse IP de l’Utilisateur, la marque et le
          modèle de l’appareil, l’opérateur mobile, la date et l’heure exacte
          des consultations des produits, la date d’accouchement et le noms des
          médecins.
        </p>
        <p>
          Le Charrette Club sauvegarde et stock les données jusqu’à qu’ils ne
          soient plus utiles aux services de l’Application ou jusqu’à
          suppression du compte personnel de l’Utilisateur. Le Charrette Club
          s’engage à supprimer les données personnelles liées au compte
          personnel supprimé dans les 6 mois à compter de cette suppression.
          Dans le cas où l’Utilisateur fait une demande de suppression de ces
          données, Le Charrette Club s’engage à satisfaire cette demande sous un
          mois à compter de la réception de cette dernière.
        </p>
        <p>
          La destruction des données personnelles de l’Utilisateur s’effectue
          sur tout les supports où elles sont conservés et stockés.
        </p>
        <h3 className="!text-xl !leading-snug">
          14.4 – Droit à la portabilité des données personnelles
        </h3>
        <p>
          L’Utilisateur a la possibilité, s’il le souhaite, de récupérer les
          données stockées par le Charrette Club dans un format ouvert et
          lisible par machine. Le Charrette Club s’engage également à
          transmettre, sur demande expresse de l’Utilisateur, ces données vers
          un système d’information en vue de leur réutilisation à des fins
          personnelles.
        </p>
        <p>
          Ces actions s’effectuent sur demande expresse et écrite de
          l’Utilisateur via un courrier électronique à l’adresse :
          bonjour@charrette.club Le Charrette Club s’engage à répondre et
          effectuer la transmission de données sous trois mois à partir de la
          réception de la demande.
        </p>
        <p>
          En cas d’incident quelconque qui ne serait pas du fait du Charrette
          Club, ce dernier ne pourra être tenu pour responsable d’un quelconque
          dommage survenu lors de la phase de transmission des données de
          l’Utilisateur. La sécurisation du serveur ou de la machine sur lequel
          la transmission des données doit s’effectuer revient à l’Utilisateur;
          par conséquent ce dernier est responsable en cas de survenance d’un
          incident sur les services du Charrette Club qui serait liée
          directement ou indirectement à la transmission de ces données.
        </p>
        <h3 className="!text-xl !leading-snug">
          14.5 – L’utilisation des cookies, identifiants et du fichier
          d’activité
        </h3>
        <p>
          Dans le but de perfectionner et d’améliorer les services proposés par
          La Fraise, en termes de rendement du système et de facilité d’usage,
          ainsi que pour proposer de l’information utile sur les produits et
          services; des informations peuvent être recueillies automatiquement et
          conservées dans les fichiers de registre (log files) en provenance des
          ordinateurs ou terminaux utilisés. Ce sont des données non
          personnelles telles que : l’adresse IP, le type de navigateur, langue
          sélectionnée, le système d’exploitation, le fournisseur d’accès
          Internet (ISP) ainsi que la date et l’heure. (à compléter si besoin)
        </p>
        <p>
          Ces informations sont utilisées de façon globale pour améliorer la
          gestion de l’Application, analyser les tendances et recueillir des
          données démographiques de l’Utilisateur. Si des données non
          personnelles sont utilisées en combinaison avec les Données
          Personnelles alors l’ensemble de ces données sera qualifié de Données
          Personnelles et sera dès lors traité conformément au présent article
          14.
        </p>
        <p>
          Afin d’optimiser les services de La Fraise, les messages envoyés par
          courrier électronique, les services onlines, les publicités et les
          applications interactives peuvent utiliser les “cookies” ou les
          “identifiants anonymes” de l’utilisateur (en ce qui concerne les Sites
          web).
        </p>
        <h4>Que sont les cookies?</h4>
        <p>
          Un cookie est un petit fichier, habituellement formé par des lettres
          et des nombres, envoyés par serveur web du Charrette Club ou par
          l’application à un fichier de cookies du navigateur de l’Utilisateur.
          Ceci permet à La Fraise de se souvenir de la présence de l’Utilisateur
          lors de l’établissement d’une nouvelle connexion entre au serveur de
          La Fraise et le navigateur de l’Utilisateur. Le principal objectif
          d’un cookie est de permettre au serveur de La Fraise de présenter des
          pages web personnalisées afin d’individualiser les services proposés
          par l’Application et d’adapter les préférences personnelles de
          l’Utilisateur.
        </p>
        <h4>Que sont les identifiants ou sondes?</h4>
        <p>
          Un identifiant anonyme est une chaîne de caractères aléatoires qui
          s’utilise avec la même finalité que les cookies sur des plateformes
          sur lesquelles la technologie des cookies est indisponible, ceci
          inclut certains types d’appareils mobiles ainsi que les applications
          installées.
        </p>
        <h2
          id="article-16"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 16 – Accès à l’application par connexion internet
        </h2>
        <p>
          L’Utilisateur devra avoir un accès internet afin de pouvoir utiliser
          l’Application dans toutes ces fonctionnalités. L’accès à internet
          relève entièrement du fait de l’Utilisateur.
        </p>
        <p>
          Le Charrette Club n’est pas responsable du mauvais fonctionnement des
          opérateurs téléphoniques et des fournisseurs d’accès Internet auxquels
          l’Utilisateur aura eu recours.
        </p>
        <h2
          id="article-17"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 17 – Fermeture de compte
        </h2>
        <p>
          Dans le cas contraire où d’une transmission de données fausses,
          obsolètes ou incomplètes, Le Charrette Club se réserve le droit de
          fermer temporairement ou définitivement le compte personnel de
          l’Utilisateur. Cette action aura pour effet de refuser l’accès à
          l’Application à l’Utilisateur. La fermeture du compte se fera sans
          préavis et n‘ouvre aucun droit à l'Utilisateur d’être indemnisé.
        </p>
        <p>
          Cette sanction sera également applicable dans le cas où l’Utilisateur
          ouvre plusieurs compte personnel. En effet, l’Utilisateur s’engage à
          ne créer qu’un seul compte personnel correspondant à son identité.
        </p>
        <h2
          id="article-18"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 18 – Réclamations
        </h2>
        <p>
          Conformément à l'article 6. I. alinéa 7 de la Loi n° 2004-575 du 21
          juin 2004 pour la confiance dans l'économie numérique, le site
          internet de La Fraise permet à l’Utilisateurs de l’Application, par
          l’intermédiaire du Formulaire de Contact dans la rubrique « Contact /
          suggestions », de porter à la connaissance du Charrette Club tout
          comportement ou contenu qui lui semble illicite et/ou contraire aux
          présentes CGU, notamment toutes données faisant l'apologie des crimes
          contre l'humanité, incitant à la haine raciale ou la pornographie
          enfantine, incitant à la violence ou attentatoires à la dignité
          humaine, ainsi que contre les infractions visées au cinquième et
          huitième alinéas de l'article 24 de la loi du 29 juillet 1881 sur la
          liberté de la presse, et aux articles 227-23 et 227-24 du Code pénal.
        </p>
        <h2
          id="article-19"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 19 – Évolution des conditions générales d’utilisation
        </h2>
        <p>
          Le Charrette Club se réserve la possibilité de faire évoluer les
          présentes Conditions Générales d’Utilisation. L’Utilisateur sera
          averti de la mise en ligne des nouvelles CGU et sera fortement invité
          à les lire attentivement.
        </p>
        <p>
          Les mises à jour des CGU seront disponibles sur le site internet de La
          Fraise dans la rubrique CGU et sur l’Application dans “Conditions
          générales”.
        </p>
        <h2
          id="article-20"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 20 – Nullité d’une clause des CGU
        </h2>
        <p>
          La nullité ou l’impossibilité de mise en œuvre de l’une des clauses
          des présentes CGU, si elle ne remet pas en cause l’équilibre
          contractuel, n’affectera que la clause concernée et n’entraînera pas
          l’annulation des présentes CGU.
        </p>
        <p>
          L’Utilisateur s’engage à lire attentivement le contenu des Conditions
          Générales d’Utilisation de La Fraise, et accepte expressément et sans
          réserve toutes les règles et obligations qui y sont exposées.
        </p>
        <h2
          id="article-21"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 21 – Résiliation
        </h2>
        <p>
          La Fraise pourrait être interrompu de manière temporaire ou
          définitive, notamment en cas de cessation par Charrette Club de
          l’activité, en cas de liquidation judiciaire de la société Le
          Charrette Club. Par conséquent, les présentes CGU seraient alors
          résiliées de plein droit.
        </p>
        <p>
          En cas de décès de l’Utilisateur, les relations contractuelles entre
          celui-ci et Charrette Club seront résiliées de plein droit. Le
          Charrette Club s’engage à désactiver le compte personnel sur
          production des pièces justificatives pertinentes des ayants droit. Le
          contenu de ce compte ne pourra être transmis aux ayants droit que sur
          décision de Justice.
        </p>
        <p>
          Le Charrette Club se réserve le droit de bloquer, résilier ou
          supprimer le compte de l’Utilisateur ou son accès à l’Application de
          façon temporaire ou définitive en cas de violation des présentes CGU
          conformément aux articles 6 et 9 des présentes. Cette action n’ouvre
          aucun droit pour l’Utilisateur à une quelconque indemnisation ou
          réparation.
        </p>
        <p>
          L’Utilisateur peut se désinscrire quand il le souhaite et à tout
          moment de l’Application en envoyant une demande à
          bonjour@charrette.club.
        </p>
        <h2
          id="article-22"
          className="scroll-mt-28 !mt-12 !mb-6 !text-2xl md:!text-3xl !leading-snug"
        >
          Article 22 – Loi applicable - Litige - Langue
        </h2>
        <p>
          La conclusion, l'interprétation et la validité des présentes
          Conditions Générales d'Utilisation et de l’ensemble des contrats qui
          en découlent sont soumis uniquement à la Loi et la Réglementation
          française en vigueur, à l'exclusion de toute autre législation, et ce
          quelle que soit la nationalité de l’Utilisateur. Cela s’applique
          concernant les règles de fond et de formes.
        </p>
        <p>
          Tout litige ou contestation relatif à l'interprétation, l’exécution ou
          l’inexécution, résiliation des présentes CGU devra au préalable
          essayer d’être réglé à l’amiable. A défaut, d’accord amiable entre les
          parties; les juridictions compétentes sont uniquement celles du
          ressort du siège social de Charrette Club.
        </p>
        <p>
          En cas de difficulté d'interprétation, la version en langue française
          des présentes CGU prévaut sur toute autre version qui serait traduite
          dans une autre langue.
        </p>
      </article>
    </main>
  </Layout>
);

export default Legal;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { ns: { in: ["general"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
